<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title" *ngIf="inner_Alert.id==0">Register New Notice</h5>
    <h5 class="card-title" *ngIf="inner_Alert.id>0">Edit Notice </h5>
    <form>
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Notice Title</label>
          <input [(ngModel)]="Title" name="Title" type="text" class="form-control" placeholder="Type here...">
        </div>
        <div class="form-group col-md-4" *ngIf="inner_Alert.user_id==0">
          <label for="exampleInputEmail1">Users</label>
          <select class="custom-select" [(ngModel)]="Customer" name="Customer">
            <option value="0">-- Select ---</option>
            <option value="1">Behfa Users</option>
            <option value="2">Customers</option>
          </select>
        </div>

        <div class="form-group col-md-4" *ngIf="inner_Alert.user_id==0">
          <label for="exampleInputEmail1">Expiration Date</label>
          <input type="text" [(ngModel)]="ExpirationDate" name="ExpirationDate" #datepickerBuy
            placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerBuy"></ng-persian-datepicker>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Notice Description</label>
          <ckeditor name="editorData" [(ngModel)]="model.editorData" [config]="config" [editor]="Editor"></ckeditor>
        </div>
      </div>

      <br />
      <br />
      <br />
      <br />

      <div *ngIf="inner_Alert.user_id==0">

        <div class="row">
          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">
              Attachments
              <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
                  class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
              class="form-control" placeholder="Type here...">
          </div>
        </div>

        <button type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc" class="btn btn-info"
          style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Attachment </button>

        <br />
        <br />

        <div class="table-responsive" *ngIf="UploadImageSrc_List.length>0">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>File</th>

                <th>Actions</th>
              </tr>
            </thead>
            <tbody>

              <tr *ngFor="let item of UploadImageSrc_List">

                <td>{{UploadImageSrc_List.indexOf(item)+1}}</td>
                <td>

                  <a target="_blank" *ngIf="item.includes('.pdf')" href="{{BaseUrl}}File/Alert/{{item}}"
                    class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>


                  <img *ngIf="!item.includes('.pdf')" (click)="openModal(templateImage,item)"
                    style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Alert/{{item}}" />
                </td>
                <td>
                  <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;"
                          (click)="UploadImageSrc_List_Delete(UploadImageSrc_List.indexOf(item))"
                          class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                      </div>
                    </div>
                  </div>
                </td>

              </tr>
            </tbody>
          </table>
        </div>

      </div>

      <br />
      <br />

      <div class="row" [hidden]="Customer!='1'">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Organizational Chart</label>
          <app-Chart_Check
            [DataList_Chart]="DataList_Chart"
            [Selected_Chart]="Selected_Tag"
            (On_Get_Selected_Tag)="OnGet_Selected_Tag($event)">
  
          </app-Chart_Check>
        </div>

        <br />
        <br />
      </div>

      <div>

      </div>
      


      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing && inner_Alert.id==0" type="button" (click)="onSubmitForm()" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register Information </button>
      <button *ngIf="!InProccessing && inner_Alert.id>0 && inner_Alert.user_id==0" type="button"
        (click)="onSubmitForm()" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i>
        Edit Information </button>
    </form>
  </div>
</div>


<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> View Image </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseUrl}}File/Alert/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Alert/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> Download </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">Close</button>
  </div>
</ng-template>
